import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { groupBy, kebabCase } from 'lodash';
import { defineMessages, injectIntl, intlShape } from 'react-intl';

import { media } from '../../../styles/style-utils';
import { legacyType } from '../../../styles/typography';
import { getYear } from '../../../dates';

import Section from '../../common/Section';
import PressRelease from './PressRelease';
import PressMention from './PressMention';
import MultiColumnsGrid from '../gridBlock/MultiColumnsGrid';
import TextBlockWithIcon from '../textBlock/TextBlockWithIcon';
import Anchor from '../utils/Anchor';
import { BLOCK_TYPE } from '../utils/Contentful';

const messages = defineMessages({
  pressGridSubtitle: {
    id: 'press-grid.subtitle-2',
    defaultMessage: '{type} for {year}',
  },
  pressMentions: {
    id: 'press.mentions',
    defaultMessage: 'Press Mentions',
  },
  pressReleases: {
    id: 'press.releases',
    defaultMessage: 'Press Releases',
  },
});

const Wrapper = styled(Section)`
  padding: var(--default-vertical-padding) 0rem;
  text-align: left;

  ${media.mediumLarge`
    padding: var(--default-vertical-padding) 3rem;
    text-align: center;
  `}

  .textBlock {
    padding: 0 var(--default-horizontal-padding);
  }
`;

const Item = styled.div`
  text-align: left;
  width: 100%;
  padding: 3rem 1rem;
  background-color: var(--c-black);
  width: 100%;
  position: relative;

  ${media.mediumLarge`
    padding: 3rem 2rem;
  `}

  h2 {
    font-size: var(--fs-l);
    margin-bottom: 1rem;
  }
`;

const Body = styled.div`
  font-size: var(--fs-sm);
  ${legacyType('sm', 'body')};
`;

class PressGrid extends React.Component {
  state = {
    modalIsOpen: false,
    modalData: {},
  };

  getFormattedType = () => {
    const { type } = this.props;
    if (type === BLOCK_TYPE.PRESS_MENTIONS) {
      return this.props.intl.formatMessage(messages.pressMentions);
    }

    if (type === BLOCK_TYPE.PRESS_RELEASES) {
      return this.props.intl.formatMessage(messages.pressReleases);
    }

    return null;
  };

  render() {
    const { content, type } = this.props;
    const { modalData, modalIsOpen } = this.state;

    const groupedContent = groupBy(content, item => getYear(item.date));

    return (
      <React.Fragment>
        <Anchor id={kebabCase(type)} />
        <Wrapper>
          <div className="textBlock">
            <TextBlockWithIcon
              content={{ headline: this.getFormattedType() }}
              marginBottom="var(--default-vertical-padding)"
              srcBlockName={type}
            />
          </div>
          <MultiColumnsGrid numberOfColumns={3}>
            {Object.entries(groupedContent).reverse().map(this.contentToComponents)}
          </MultiColumnsGrid>
        </Wrapper>
        {modalData.pressList &&
          type === BLOCK_TYPE.PRESS_RELEASES &&
          type !== BLOCK_TYPE.PRESS_MENTIONS && (
            <PressRelease isOpen={modalIsOpen} onClose={this.closeModal} data={modalData} />
          )}
        {modalData.pressList && type === BLOCK_TYPE.PRESS_MENTIONS && (
          <PressMention isOpen={modalIsOpen} onClose={this.closeModal} data={modalData} />
        )}
      </React.Fragment>
    );
  }

  contentToComponents = ([year, pressList]) => {
    const formattedType = this.getFormattedType();
    const data = { type: formattedType, year, pressList };
    const subtitle = this.props.intl.formatMessage(messages.pressGridSubtitle, {
      type: formattedType,
      year,
    });

    return (
      <Item key={year}>
        <button onClick={() => this.openModal(data)} className="dummy-btn" aria-label={subtitle} />
        <h2>{year}</h2>
        <Body>{subtitle}</Body>
      </Item>
    );
  };

  openModal = data => {
    this.setState({ modalIsOpen: true, modalData: data });
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false, modalData: {} });
  };
}

PressGrid.propTypes = {
  content: PropTypes.array,
  type: PropTypes.string,
  intl: intlShape.isRequired,
};

export default injectIntl(PressGrid);



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/press/PressGrid.js